import React, { useState } from 'react'
import { Button } from '@components/ui/Button'
import Tabs from '@components/ui/Tabs'
import Modal from '@components/ui/Modal'
import { ReactComponent as TapeIcon } from '@svgs/illustration/tape.svg'
import { ReactComponent as TapeTrouserIcon } from '@svgs/illustration/tape-trouser.svg'
import { ReactComponent as SmallTapeTrouserIcon } from '@svgs/illustration/small-tape-trouser.svg'
import { ReactComponent as SmallTapeIcon } from '@svgs/illustration/small-tape.svg'
import SectionHeader from '@components/ui/SectionHeader'
import Translations from '@helpers/translations'
import { data } from './data'
import styles from './styles.module.scss'

const TABS_DATA = data.map(item => ({
  ...item,
  text: Translations.localise(`pages.size-chart.htm.${item.text}.text`)
}))

const HowToMeasure = () => {
  const [openMeasureModal, setMeasureModal] = useState(false)
  const toggleMeasureModal = () => {
    setMeasureModal(!openMeasureModal)
  }
  return (
    <>
      <SectionHeader
        title={Translations.localise('pages.size-chart.htm.how-to-measure')}
        className={styles.sectionHeader}
      />
      <section className={`${styles.oldFashioned}`}>
        <div className={`${styles.oldFashioned__list} grid grid--nowrap`}>
          <ul
            className={`${styles.oldFashioned__list__container} grid__container`}
          >
            <li className={`${styles.oldFashioned__item} grid__item`}>
              <div className={styles.oldFashioned__img}>
                <TapeIcon width="438" height="157.67" viewBox="0 0 800 288" />
              </div>

              <div className={styles.oldFashioned__icon}>
                <SmallTapeIcon width="45" height="45" />
              </div>

              <div className={styles.oldFashioned__item__content}>
                <h3 className={styles.oldFashioned__item__number}>
                  {Translations.localise('pages.size-chart.htm.step-1.title')}
                </h3>

                <h4 className={styles.oldFashioned__item__title}>
                  {Translations.localise(
                    'pages.size-chart.htm.step-1.find-a-tape'
                  )}
                </h4>

                <p className={styles.oldFashioned__item__copy}>
                  {Translations.localise(
                    'pages.size-chart.htm.step-1.which-tape'
                  )}
                </p>
              </div>
            </li>

            <li className={`${styles.oldFashioned__item} grid__item`}>
              <div className={styles.oldFashioned__img}>
                <TapeTrouserIcon
                  width="438"
                  height="157.67"
                  viewBox="0 0 800 288"
                />
              </div>

              <div className={styles.oldFashioned__icon}>
                <SmallTapeTrouserIcon width="45" height="45" />
              </div>

              <div className={styles.oldFashioned__item__content}>
                <h3 className={styles.oldFashioned__item__number}>
                  {Translations.localise('pages.size-chart.htm.step-2.title')}
                </h3>
                <h4 className={styles.oldFashioned__item__title}>
                  {Translations.localise(
                    'pages.size-chart.htm.step-2.measure-your-favourite'
                  )}
                </h4>
                <p className={styles.oldFashioned__item__copy}>
                  {Translations.localise(
                    'pages.size-chart.htm.step-2.find-your-favourite'
                  )}
                </p>
                <div className={styles.oldFashioned__item__button}>
                  <Button variant="secondary" onClick={toggleMeasureModal}>
                    {Translations.localise(
                      'pages.size-chart.htm.how-to-measure'
                    )}
                  </Button>
                </div>
              </div>
              {openMeasureModal && (
                <Modal
                  content={
                    <Tabs
                      data={TABS_DATA}
                      title={Translations.localise(
                        'pages.size-chart.htm.step-2.measure-your-favourite'
                      )}
                      byline={Translations.localise(
                        'pages.size-chart.htm.step-2.grab-a-pair'
                      )}
                      extraClass="size-chart"
                    />
                  }
                  onClose={toggleMeasureModal}
                  openedModal={openMeasureModal}
                />
              )}
            </li>
          </ul>
        </div>
      </section>
    </>
  )
}

export default HowToMeasure
